"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactComponents = require("@cimpress/react-components");

var LoudspeakerHeader = function LoudspeakerHeader(_ref) {
  var title = _ref.title,
      showRobot = _ref.showRobot;
  var Robot = _reactComponents.shapes.Robot;
  return _react.default.createElement("div", {
    className: "loudspeakerTitle"
  }, showRobot ? _react.default.createElement(Robot, {
    bsStyle: "info",
    alternate: true
  }) : null, _react.default.createElement("div", {
    className: "loudspeakerTitle__text"
  }, _react.default.createElement("span", null, title)));
};

LoudspeakerHeader.propTypes = {
  title: _propTypes.default.string.isRequired,
  showRobot: _propTypes.default.bool
};
LoudspeakerHeader.defaultProps = {
  showRobot: true
};
var _default = LoudspeakerHeader;
exports.default = _default;